export default{
    zqPayOrder:{
        showObj:{
            show1:'结算单号：',
            show2:'确认支付金额：',
            show3:'结算单金额：',
            show4:'本账期结算单本金，即所含账期订单总金额。其中账期商品总金额',
            show5:'逾期滞纳金：',
            show6:'逾期滞纳金按天收取比例',
            show7:'应结金额：',
            show8:'本次应结金额=结算单金额',
            show9:'本次应结金额=结算单金额+逾期滞纳金',
            show10:'已逾期3天',
        }
    }
}